/* Enhances the native Shopify contact form; submits no analytics events. */
(() => {
  const initialise = (root = document) => {
    root.querySelectorAll('[data-professional-page]').forEach((page) => {
      if (page.dataset.professionalReady) return;
      page.dataset.professionalReady = 'true';
      const form = page.querySelector('form[action*="contact"]');
      if (!form) return;

      // Campaign slugs from this page only. No cookies or cross-session storage.
      const parameters = new URLSearchParams(window.location.search);
      form.querySelectorAll('[data-pro-utm]').forEach((field) => {
        const value = parameters.get(field.dataset.proUtm) || '';
        field.value = value.length <= 100 && /^[a-z0-9_-]*$/i.test(value)
          && !/\d{7,}/.test(value) ? value : '';
      });

      const service = form.querySelector('[name="contact[Servicio]"]');
      const ctaField = form.querySelector('[data-pro-cta]');
      const services = {
        mantenimiento: 'Afilado y mantenimiento',
        renting: 'Renting de cuchillos'
      };
      page.querySelectorAll('[data-professional-cta]').forEach((link) => {
        link.addEventListener('click', () => {
          const cta = link.dataset.professionalCta;
          if (!['hero', 'mantenimiento', 'renting'].includes(cta)) return;
          if (ctaField) ctaField.value = cta;
          if (service && services[cta]) service.value = services[cta];
        });
      });

      form.addEventListener('submit', () => {
        const now = new Date();
        const reference = form.querySelector('[data-pro-reference]');
        const submittedAt = form.querySelector('[data-pro-time]');
        if (submittedAt) submittedAt.value = now.toISOString();
        if (reference && !reference.value) {
          const suffix = window.crypto && typeof window.crypto.randomUUID === 'function'
            ? window.crypto.randomUUID().slice(0, 8)
            : Math.random().toString(36).slice(2, 10);
          reference.value = `NG-${now.toISOString().slice(0, 10)}-${suffix}`;
        }
      });

      // Only server-rendered status can confirm success or report errors.
      const status = form.querySelector('[data-professional-errors], [data-professional-success]');
      if (status) status.focus({ preventScroll: false });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise(), { once: true });
  } else {
    initialise();
  }
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
